<template>
  <div class="tw:flex tw:flex-col">
    <div class="tw:relative">
      <svg>
        <circle
          class="tw:fill-none"
          :cx="cx"
          :cy="cy"
          :r="radius"
        />
        <circle
          class="tw:fill-none"
          :cx="cx"
          :cy="cy"
          :r="radius"
          :style="`--percent: ${percentage}`"
        />
      </svg>

      <slot name="text" />
    </div>
  </div>
</template>

<script lang="ts">
interface PotentialAudienceReachCircularProgressProps {
  cx?: number;
  cy?: number;
  percentage: number;
  radius?: number;
}
</script>

<script setup lang="ts">
withDefaults(defineProps<PotentialAudienceReachCircularProgressProps>(), {
  cx: 46,
  cy: 32,
  radius: 28,
});
</script>

<style lang="scss" scoped>
svg {
  circle {
    /* Base circle styles */
    stroke: var(--s-color-blue-6);
    stroke-width: 8;
    stroke-linecap: square;

    /* Background circle */
    &:first-of-type {
      stroke: var(--s-color-blue-6);
    }

    /* Progress circle */
    &:last-of-type {
      stroke: var(--s-color-blue-8);
      stroke-dasharray: 160px;
      stroke-dashoffset: calc(160px - (160px * var(--percent)) / 100);
    }
  }
}
</style>
